module.exports = __webpack_public_path__ + "static/8-ed6f41507d25ba5b0142e477d105fb2b.png";